ready().then(function() {
    var spinner = $('.page-loader-spinner');

    window.openPageLoader = () => {
        var removespinnertime = 25000;

        spinner.fadeIn('slow');

        setTimeout(function() { // remove the spinner since nothing seems to be loading or someone opened the link on a new tab
            removePageLoader();
        }, removespinnertime);
    };

    window.removePageLoader = () => {
        spinner.fadeOut('slow');
    }
});